import styled from 'styled-components';
import {colorTheme} from '../../../../mixin/colorTheme';
import {gradientGimmick} from '../../../../../shared-components/mixin/gradientGimmick';
import {scrollBar} from '../../../../../shared-components/mixin/scroll/scrollBar';

export const DatepickerStyling = styled.div`
    ${colorTheme({
        '--react-datepicker-header-background-color': {dark: 'var(--black-14)', light: 'var(--purple-08)'},
        '--datepicker-header-text-color': {dark: 'var(--white-00)', light: 'var(--purple-01)'},
        '--datepicker-current-day-name-color': {dark: 'var(--white-00)', light: 'var(--white-00)'},
        '--react-datepicker-current-day-background-color-selected': {
            dark: 'var(--honey-00)',
            light: 'var(--purple-08)',
        },
    })};

    // ---- Main Container colors ----
    --react-datepicker-container-shadow-100: var(--form-control-dropdown-shadow);
    --react-datepicker-container-background-color-100: var(--container-background-color-100);
    --react-datepicker-container-background-color-200: var(--container-background-color-200);

    .react-datepicker-popper {
        pointer-events: none;
        z-index: 202;
    }
    .react-datepicker {
        pointer-events: visible;
        cursor: default;
        border: none;
        box-shadow: var(--react-datepicker-container-shadow-100);
        overflow: hidden;
        background: var(--react-datepicker-container-background-color-100);
        &-wrapper {
            width: 100%;
        }
        &::before,
        &__time-container::before {
            ${gradientGimmick};
            z-index: 1;
        }

        &__triangle {
            display: none;
        }

        &__month-container {
            background: var(--react-datepicker-container-background-color-100);
        }

        &__header {
            background: var(--react-datepicker-header-background-color);
            padding: 24px 16px 64px;
            height: 77px;
            border: none;
        }
        &__current-month {
            color: var(--datepicker-header-text-color);
            font-size: 25px;
            text-align: left;
        }
        &__time-container {
            border-left: none;
        }
        &__time-list {
            background: var(--react-datepicker-container-background-color-200);
        }

        .react-datepicker-time__header {
            color: var(--datepicker-header-text-color) !important;
        }

        &__navigation {
            width: 22px;
            top: 2px;

            &.react-datepicker__navigation {
                &--next,
                &--previous {
                    .react-datepicker__navigation-icon.react-datepicker__navigation-icon--next::before,
                    .react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous::before {
                        border-color: var(--datepicker-header-text-color);
                        border-width: 1.5px 1.5px 0 0;
                    }
                }
                &--next {
                    right: unset;
                    left: 40px;
                }
                &--previous {
                    left: var(--space-sm);
                }
            }
        }

        &__input-container {
            button {
                color: var(--default-text-color);
            }
        }

        &__day,
        &__time-list-item {
            color: var(--default-text-color);
            font-size: var(--text-size-default);
            font-weight: 500;

            &.react-datepicker__day--selected,
            &.react-datepicker__day--in-range,
            &.react-datepicker__day--keyboard-selected.react-datepicker__day--today,
            &.react-datepicker__time-list-item--selected {
                color: var(--datepicker-header-text-color);
                background-color: var(--react-datepicker-current-day-background-color-selected) !important;

                &:hover {
                    color: var(--white-00);
                    background: var(--primary);
                }
            }

            &.react-datepicker__day--outside-month {
                color: var(--label-text-color-100);
            }

            &.react-datepicker__day--disabled {
                color: var(--form-control-disabled-text-color) !important;
                cursor: not-allowed;
                background: var(--form-control-disabled-background-color);
                border-radius: 4px;
                opacity: 0.5;
                &:hover {
                    background: var(--form-control-disabled-background-color) !important;
                }
            }

            &:hover {
                color: var(--white-00);
                background: var(--primary) !important;
            }
        }
        &__week-number {
            color: var(--label-text-color-100);
            font-size: var(--text-size-xx-small);
            font-weight: 900;
            &::before {
                content: '#';
            }
        }

        &__day-name {
            color: var(--datepicker-header-text-color);
            font-size: var(--text-size-small);
        }

        &__time-list {
            ${scrollBar};
            ${colorTheme({
                //== scroll ===
                '--scroll-bar-background ': {
                    dark: 'var(--black-14)                          ',
                    light: 'var(--purple-00)',
                },
                '--scroll-bar-border     ': {
                    dark: 'var(--scroll-bar-background )   ',
                    light: 'var(--scroll-bar-background )',
                },
                '--scroll-bar-thumb      ': {
                    dark: 'var(--black-03)                             ',
                    light: 'var(--white-00)',
                },
                '--scroll-bar-thumb-hover': {
                    dark: 'var(--black-03)                            ',
                    light: 'var(--scroll-bar-background )',
                },

                // // === Mozilla mod === // //
                '--scroll-bar-background-moz      ': {
                    dark: 'var(--black-03)                              ',
                    light: 'var(--white-00)',
                },
                '--scroll-bar-thumb-moz ': {
                    dark: 'var(--black-14)                          ',
                    light: 'var(--purple-00)',
                },
            })};
        }
    }
`;
